import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  setActiveTrigger: ['trigger'],

  toggleFillingMaterialModal: ['isOpen'],
  resetFillingMaterialModal: null,

  setCustom: ['options'],
  setCustomersOption: ['option'],
  setCustomDSPMilling: ['isOn'],
  setCustomTransparent: ['isOn'],

  setDsp: ['options'],
  setDspOption: ['option'],
  setDspManufacturer: ['manufacture'],
  setDspSearch: ['search'],
  setDspUvPrinting: ['isOn'],
  setDspUvPrintType: ['printType'],

  setMirror: ['options'],
  setMirrorType: ['mirrorType'],
  setMirrorMatting: ['isOn'],
  setMirrorRearMatting: ['isOn'],
  setMirrorFullMatting: ['isOn'],
  setMirrorTransparent: ['isOn'],
  setMirrorPaintingColor: ['color'],
  setMirrorUvPrinting: ['isOn'],
  setMirrorUvPrintType: ['printType'],
  setMirrorArmoredFilm: ['isOn'],
  setMirrorLamination: ['isOn'],
  setMirrorSearch: ['search'],

  setLacobel: ['options'],
  setLacobelType: ['lacobelType'],
  setLacobelMatting: ['isOn'],
  setLacobelRearMatting: ['isOn'],
  setLacobelFullMatting: ['isOn'],
  setLacobelTransparent: ['isOn'],
  setLacobelPaintingColor: ['color'],
  setLacobelUvPrinting: ['isOn'],
  setLacobelUvPrintType: ['printType'],
  setLacobelArmoredFilm: ['isOn'],
  setLacobelLamination: ['isOn'],
  setLacobelSearch: ['search'],

  setGlass: ['options'],
  setGlassType: ['glassType'],
  setGlassMatting: ['isOn'],
  setGlassFullMatting: ['isOn'],
  setGlassArmoredFilm: ['isOn'],
  setGlassLamination: ['isOn'],
  setGlassTransparent: ['isOn'],
  setGlassUvPrintType: ['printType'],
  setGlassIsOneColorPainted: ['isOn'],
  setGlassIsTwoColorsPainted: ['isOn'],
  setGlassPaintingColors: ['colors'],
  setGlassUvPrinting: ['isOn'],
  setGlassPhotoPrinting: ['isOn'],
  setGlassPhotoPrintType: ['printType'],
  setGlassSearch: ['search'],
});

export const ModalTypes = Types;
export default Creators;
